import { StaticImageData } from 'next/image';

import bitetimeDesktopBrownTrout2x from '../assets/bitetime_desktop_brown_trout@2x.png';
import bitetimeDesktopCrevalleJack2x from '../assets/bitetime_desktop_jack_crevalle@2x.png';
import bitetimeDesktopLargemouthBass2x from '../assets/bitetime_desktop_largemouth_bass@2x.png';
import bitetimeDesktopNorthernPike2x from '../assets/bitetime_desktop_northern_pike@2x.png';
import bitetimeDesktopSnook2x from '../assets/bitetime_desktop_snook@2x.png';
import bitetimeDesktopStripedBass2x from '../assets/bitetime_desktop_striped_bass@2x.png';
import bitetimeDesktopTrahira2x from '../assets/bitetime_desktop_trahira@2x.png';
import bitetimeMobileBrownTrout2x from '../assets/bitetime_mobile_brown_trout@2x.png';
import bitetimeMobileCrevalleJack2x from '../assets/bitetime_mobile_jack_crevalle@2x.png';
import bitetimeMobileLargemouthBass2x from '../assets/bitetime_mobile_largemouth_bass@2x.png';
import bitetimeMobileNorthernPike2x from '../assets/bitetime_mobile_northern_pike@2x.png';
import bitetimeMobileSnook2x from '../assets/bitetime_mobile_snook@2x.png';
import bitetimeMobileStripedBass2x from '../assets/bitetime_mobile_striped_bass@2x.png';
import bitetimeMobileTrahira2x from '../assets/bitetime_mobile_trahira@2x.png';
import bitetimeTabletBrownTrout2x from '../assets/bitetime_tablet_brown_trout@2x.png';
import bitetimeTabletCrevalleJack2x from '../assets/bitetime_tablet_jack_crevalle@2x.png';
import bitetimeTabletLargemouthBass2x from '../assets/bitetime_tablet_largemouth_bass@2x.png';
import bitetimeTabletNorthernPike2x from '../assets/bitetime_tablet_northern_pike@2x.png';
import bitetimeTabletSnook2x from '../assets/bitetime_tablet_snook@2x.png';
import bitetimeTabletStripedBass2x from '../assets/bitetime_tablet_striped_bass@2x.png';
import bitetimeTabletTrahira2x from '../assets/bitetime_tablet_trahira@2x.png';

export interface DynamicTopSpeciesProps {
  speciesName: string;
  externalID: string;
  biteTimeImgMobile: StaticImageData;
  biteTimeImgTablet: StaticImageData;
  biteTimeImgDesktop: StaticImageData;
  isDefault?: boolean;
}

export const DYNAMIC_TOP_SPECIES: DynamicTopSpeciesProps[] = [
  {
    speciesName: 'Largemouth Bass',
    externalID: 'SCQyR-cP',
    biteTimeImgMobile: bitetimeMobileLargemouthBass2x,
    biteTimeImgTablet: bitetimeTabletLargemouthBass2x,
    biteTimeImgDesktop: bitetimeDesktopLargemouthBass2x,
    isDefault: true,
  },
  {
    speciesName: 'Snook',
    externalID: '-t-FXpCH',
    biteTimeImgMobile: bitetimeMobileSnook2x,
    biteTimeImgTablet: bitetimeTabletSnook2x,
    biteTimeImgDesktop: bitetimeDesktopSnook2x,
  },
  {
    speciesName: 'Striped Bass',
    externalID: 'gOVMRtUl',
    biteTimeImgMobile: bitetimeMobileStripedBass2x,
    biteTimeImgTablet: bitetimeTabletStripedBass2x,
    biteTimeImgDesktop: bitetimeDesktopStripedBass2x,
  },
  {
    speciesName: 'Crevalle jack',
    externalID: 'QYSotwy0',
    biteTimeImgMobile: bitetimeMobileCrevalleJack2x,
    biteTimeImgTablet: bitetimeTabletCrevalleJack2x,
    biteTimeImgDesktop: bitetimeDesktopCrevalleJack2x,
  },
  {
    speciesName: 'Northern Pike',
    externalID: 'HSc8zwDz',
    biteTimeImgMobile: bitetimeMobileNorthernPike2x,
    biteTimeImgTablet: bitetimeTabletNorthernPike2x,
    biteTimeImgDesktop: bitetimeDesktopNorthernPike2x,
  },
  {
    speciesName: 'Brown trout',
    externalID: 'qluM92F5',
    biteTimeImgMobile: bitetimeMobileBrownTrout2x,
    biteTimeImgTablet: bitetimeTabletBrownTrout2x,
    biteTimeImgDesktop: bitetimeDesktopBrownTrout2x,
  },
  {
    speciesName: 'Trahira',
    externalID: '08oBrlG9',
    biteTimeImgMobile: bitetimeMobileTrahira2x,
    biteTimeImgTablet: bitetimeTabletTrahira2x,
    biteTimeImgDesktop: bitetimeDesktopTrahira2x,
  },
];
